/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouteReuseStrategy, DetachedRouteHandle } from '@angular/router';

@Injectable()
export class CustomReuseStrategy implements RouteReuseStrategy {
	public shouldAttach(route: ActivatedRouteSnapshot) {
		return false;
	}
	public shouldDetach(route: ActivatedRouteSnapshot) {
		return false;
	}
	public store(route: ActivatedRouteSnapshot, handle: DetachedRouteHandle) {}
	public retrieve(route: ActivatedRouteSnapshot): null {
		return null;
	}
	public shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot) {
		//check for a special data flag on the route, if set, then don't reuse
		if (future.data && future.data['noReuse']) {
			return false;
		}
		//otherwise default angular route handling
		return curr.routeConfig === future.routeConfig;
	}
}
